export default __webpack_public_path__ + "static/media/component-search.bb6d687e.png";